import Vue from 'vue'
import Router from 'vue-router'

import {
  constantRouterMap_P, constantRouterMap_M
} from '../../config/router.config'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)

const routeSM = [
  {
    path: '/m_home',
    name: "m_home",
    title: "系统首页",
    icon: "home-o",
    show: true,
    component: () => import('../views/Mobile/home.vue'),
  },
  {
    path: '/m_cunstomer_index',
    name: "m_cunstomer_index",
    title: "客户管理",
    icon: "label-o",
    show: true,
    component: () => import('../views/Mobile/Customer/index.vue'),
  },
  {
    path: '/m_contract_index',
    name: "m_index",
    title: "合同管理",
    icon: "balance-list-o",
    show: true,
    component: () => import('../views/Mobile/Contract/index.vue'),
  }]
//../views/PC/index.vue
const routeSP = [
  {
    path: '/pc_home',
    name: "pc_home",
    title: "系统首页",
    icon: "el-icon-s-home",
    show: true,
    component: () => import('../views/PC/home.vue'),
  },
  {
    path: '/pc_user_index',
    name: "pc_user_index",
    title: "人员管理",
    icon: "el-icon-user",
    show: true,
    component: () => import('../views/PC/User/index.vue'),
  },
  {
    path: '/pc_Permission_index',
    name: "pc_Permission_index",
    title: "权限管理",
    icon: "el-icon-s-check",
    show: true,
    component: () => import('../views/PC/Permission/index.vue'),
  },
  {
    path: '/pc_customer_index',
    name: "pc_customer_index",
    title: "客户管理",
    icon: "el-icon-s-custom",
    show: true,
    component: () => import('../views/PC/Customer/index.vue'),
  },
  {
    path: '/pc_part_index',
    name: "pc_part_index",
    title: "物料管理",
    icon: "el-icon-document-copy",
    show: true,
    component: () => import('../views/PC/Part/index.vue'),
  },
  {
    path: '/pc_salesLead_index',
    name: "pc_salesLead_index",
    title: "线索管理",
    icon: "el-icon-connection",
    show: true,
    component: () => import('../views/PC/SalesLead/index.vue'),
  },
  {
    path: '/pc_project_index',
    name: "pc_project_index",
    title: "项目管理",
    icon: "el-icon-tickets",
    show: true,
    component: () => import('../views/PC/Project/index.vue'),
  },
  {
    path: '/pc_contract_index',
    name: "pc_contract_index",
    title: "合同管理",
    icon: "el-icon-reading",
    show: true,
    component: () => import('../views/PC/Contract/index.vue'),
  },
  {
    path: '/pc_contact_index',
    name: "pc_contact_index",
    title: "联系人管理",
    icon: "el-icon-notebook-1",
    show: true,
    component: () => import('../views/PC/Contact/index.vue'),
  },
  {
    path: '/pc_unpaid_project',
    name: "pc_unpaid_project",
    title: "项目统计",
    icon: "el-icon-pie-chart",
    show: true,
    component: () => import('../views/PC/StatisticRecord/UnPaidProject.vue'),
  }
]
const type = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? 2 : 1
var routes = [];
// if (type===2) {
//   routes = [
//     {
//       path: '/',
//       redirect: '/m_home',
//       component: () => import('../views/Mobile/index.vue'),
//       children: routeSM
//     }];
// } else {
routes = [
  {
    path: '/',
    redirect: '/pc_login',
  },
  {
    path: '/pc_login',
    component: () => import('../views/PC/Login.vue'),
  }, {
    path: '/',
    redirect: '/pc_home',
    component: () => import('../views/PC/index.vue'),
    children: routeSP
  }
]
//constantRouterMap;
// }

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0
  }),
  // routes:type===1? constantRouterMap_P:constantRouterMap_M
  routes: constantRouterMap_P
})



// WEBPACK FOOTER //
// ./src/router/index.js